import * as React from 'react';
import { exportToCsv } from '@teamsnap/teamsnap-ui/dist/js/utils/export';
import { Button } from '@teamsnap/teamsnap-ui';
import { reactiveFeedbackMessage } from '../../core/apollo-cache';

interface Props {
  headers: any[];
  filename?: string;
  data: () => any[];
  auditFunction?: () => Promise<boolean>;
  isDisabled?: boolean;
  children: React.ReactNode;
  otherprops?: object;
}

const CSVLink = React.forwardRef(
  (
    {
      headers,
      data,
      children,
      otherprops,
      filename = 'csv-export.csv',
      auditFunction = null,
      isDisabled = false,
    }: Props,
    ref
  ) => {
    const [buildingExport, setBuildingExport] = React.useState(false);

    const buildExport = async () => {
      let auditResult = false;
      if (auditFunction) {
        try {
          auditResult = await auditFunction();
        } catch (error) {
          auditResult = false;
        }
      }
      if (!auditResult) {
        return new Promise((resolve, reject) => reject('Audit failed for export action'));
      }

      return new Promise((resolve, reject) => {
        setTimeout(() => {
          try {
            const exportHeaders = headers.map((header) => {
              if (typeof header == 'string') {
                return header;
              } else {
                return header['label'];
              }
            });

            const exportData = data().map((row) => {
              if (Array.isArray(row)) {
                return row;
              } else {
                return headers.map((header) => row[header['key']] || '');
              }
            });

            resolve(
              exportToCsv({
                data: exportData,
                headers: exportHeaders,
                filename: filename,
              })
            );
          } catch (error) {
            console.log(error);
            reject(error);
          }
        }, 200);
      });
    };

    const exportData = async () => {
      setBuildingExport(true);

      try {
        await buildExport();
      } catch (error) {
        reactiveFeedbackMessage({
          message: 'Something went wrong while trying export the data.',
          isError: true,
          autoclose: true,
        });
      } finally {
        setBuildingExport(false);
      }
    };

    return (
      <Button
        isDisabled={isDisabled || buildingExport}
        onClick={exportData}
        {...otherprops}
        icon={'import'}
        otherProps={{ ref }}
      >
        {children}
      </Button>
    );
  }
);

export default CSVLink;
